class SiteFooter extends HTMLElement {}

customElements.define('site-footer', SiteFooter);
